import { addClass, hasClass } from "../utils/dom";

const fixEmptyElement = element => {
  if (element && element.children && element.children.length) {
    let firstNode = null;
    let lastNode = null;
    let notEmptyCount = 0;
    for (let i = 0; i < element.children.length; i++) {
      if (element.children[i].hasChildNodes()) {
        if (!firstNode) {
          firstNode = element.children[i];
        }
        lastNode = element.children[i];
        addClass(element.children[i], "not-empty");
        notEmptyCount += 1;
      } else {
        addClass(element.children[i], "is-empty");
      }
    }
    firstNode && addClass(firstNode, "is-first");
    lastNode && addClass(lastNode, "is-last");

    addClass(element, "has-" + notEmptyCount + "-columns");
  }
};

const fixEmptyElements = () => {
  if (!hasClass("body", "wp-admin")) {
    const elements = document.querySelectorAll(
      ".wp-block-gallery, .wp-block-columns"
    );
    if (elements) {
      Array.prototype.forEach.call(elements, element => {
        fixEmptyElement(element);
      });
    }
  }
};

export default fixEmptyElements;
